<template>
    <div class="offer">
        <home-nav></home-nav>
        <img class="offer-back" src="@/assets/images/offer/offer_back.png" alt="">
        <div class="offer-box">
            <div class="offer-box-top">
                <img src="@/assets/images/offer/baojia_img_title.png" alt="">
            </div>
            <div class="offer-box-title">
                包车花多少钱，10秒知道，免费获取靠谱的包车报价
            </div>

            <el-form class="offer-box-form" ref="form" :model="form" label-width="80px">
                <div class="offer-box-form-top">
                    <div class="offer-box-form-num">
                        <div class="offer-box-form-list">
                            <div id="one" class="numberPic">
                                <img :src="pic_one" alt="">
                            </div>
                            <div id="two" class="numberPic">
                                <img :src="pic_two" alt="">
                            </div>
                            <div id="three" class="numberPic">
                                <img :src="pic_three" alt="">
                            </div>
                            <div id="four" class="numberPic">
                                <img :src="pic_four" alt="">
                            </div>
                        </div>
                        <span class="offer-box-form-span">元</span>
                    </div>
                </div>

                <el-form-item label="*出发地点">
                    <el-col :span="7">
                        <el-cascader
                                placeholder="出发城市"
                                :options="options"
                                filterable
                                v-model="form.startCity"
                                @change="startcityChange"
                        >
                        </el-cascader>
                    </el-col>
                    <el-col :span="1">
                        &nbsp;
                    </el-col>
                    <el-col :span="15">
                        <el-input v-model="form.startDetail" placeholder="详细的地址能更精准的报价哦"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="目的地点">
                    <el-col :span="7">
                        <el-cascader
                                placeholder="目的城市"
                                :options="options"
                                filterable
                                v-model="form.endCity"
                        >
                        </el-cascader>
                    </el-col>
                    <el-col :span="1">
                        &nbsp;
                    </el-col>
                    <el-col :span="15">
                        <el-input v-model="form.endDetail" placeholder="详细的地址能更精准的报价哦"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="乘车人数">
                    <el-col :span="10">
                        <el-input v-model="form.number" placeholder="乘车人数"></el-input>
                    </el-col>
                    <el-col :span="1">
                        &nbsp;
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否往返" style="width: 300px;margin: 0;">
                            <el-radio-group v-model="form.radio">
                                <el-radio label="1">是</el-radio>
                                <el-radio label="2">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-form-item>

                <el-form-item label="*手机号码">
                    <el-col :span="23">
                        <el-input oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                  v-model="form.telephone"
                                  placeholder="请输入您的手机号码，报价结果将发送至您的手机号"
                                  maxlength="11"
                        >

                        </el-input>
                    </el-col>
                </el-form-item>

                <el-form-item class="bottom-btn">
                    <el-col :span="23">
                        <el-button type="danger" @click="onSubmitOneTeam()">计算报价</el-button>
                    </el-col>
                </el-form-item>

                <div class="protect">
                    * 为了您的权益，您的隐私将被严格保密。
                </div>
            </el-form>
        </div>

        <!--底部-->
        <home-footer></home-footer>

        <div class="rightTel">
            <div class="rightTelBox" id="serve-img-area" @mouseenter="enter()" @mouseleave="leave()">
                <div class="rightTelBoxIn point-area">
                    <img v-show="hoverIcon" src="@/assets/images/customtrips/icon_phone01.png" alt="">
                    <div @click="showTelephone()" v-show="!hoverIcon" class="rightTelText">
                        获取<br>
                        号码
                    </div>
                    <div class="point point-10"></div>
                    <div class="point point-40"></div>
                    <div class="point point-shadow point-80"></div>
                </div>
                <div class="rightTelBoxOut" v-show="telShow">
                    <p class="rightTelBoxOutTop">
                        该城市调度员手机号：
                    </p>
                    <p class="rightTelBoxOutTel">
                        {{ xuniTelephone }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';
    import {mapGetters} from 'vuex';
    export default {
        name: "offer",
        components: {
            homeNav,
            homeFooter
        },
        computed: {
            ...mapGetters(['getuserIp'])
        },
        data() {
            return {
                form: {
                    startCity: [], //出发城市
                    startDetail: '', //出发城市详细地址
                    endCity: [], //目的城市
                    endDetail: '', //目的城市详细地址
                    number: '',  //乘车人数
                    radio: '1', //是否往返
                    telephone: '', //手机号码
                },

                options: [],
                pic_arr:[
                    require('@/assets/images/offer/n1.png'),
                    require('@/assets/images/offer/n2.png'),
                    require('@/assets/images/offer/n3.png'),
                    require('@/assets/images/offer/n4.png'),
                    require('@/assets/images/offer/n5.png'),
                    require('@/assets/images/offer/n6.png'),
                    require('@/assets/images/offer/n7.png'),
                    require('@/assets/images/offer/n8.png'),
                    require('@/assets/images/offer/n9.png'),
                    require('@/assets/images/offer/n0.png')
                ],
                pic_one:'',
                pic_two:'',
                pic_three:'',
                pic_four:'',
                timer:'',
                shaindex:'',
                teamList:'',
                cityId:'',
                team_id_list:"",
                cityinfo_id_list:"",


                hoverIcon: true,
                telShow: false,
                xuniTelephone: '',
                timerDjs: null,
            }
        },
        mounted:function(){
            window.scrollTo(0, 0);
            this.remainTime();
            this.getCityData();
            this.getUrl();
        },
        methods: {
            getUrl(){
                var now_url = localStorage.getItem('now_url');
                if(now_url == ''|| now_url == null || now_url == undefined){
                    var url = window.location.href;
                    localStorage.setItem('now_url', url);
                }
            },
            // 在线报价
            onSubmitOneTeam(){
                var that = this;
                var userIp = that.getuserIp;
                var url = localStorage.getItem('now_url');

                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if(that.form.startCity == undefined || that.form.startCity.length <= 0){
                    // layer.msg('出发城市不能为空~', {icon: 2});
                    this.$message('出发城市不能为空~');
                    return;
                }
                if(that.form.telephone == undefined || that.form.telephone.length <= 0){
                    // layer.msg('手机号码不能为空~', {icon: 2});
                    this.$message('手机号码不能为空~');
                    return;
                }

                if (!myreg.test(that.form.telephone)) {
                    /*layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });*/
                    this.$message('请输入正确的手机号码！');
                    return;
                }

                var index;
               /* layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/

                that.$axios.post('/CalculateQuotation', {
                    start_city: that.form.startCity[1],
                    end_city: '',
                    source: "在线报价",
                    mobile: that.form.telephone,
                    username: '',
                    people_num: '',
                    url: url,
                    info_id: userIp
                }).then((res) => {
                    // layer.closeAll();
                    res = res.data;
                    if (res.status == 200) {
                        that.form.telephone = ''
                        // layer.msg('提交成功，请耐心等待回电！', {icon: 1});
                        this.$message('提交成功，请耐心等待回电！');
                    } else {
                        // layer.msg('网络异常，请刷新！', {icon: 2});
                        this.$message('网络异常，请刷新！');
                    }
                }).catch((error) => {
                    // layer.closeAll();
                    console.log(error);
                    // layer.msg('系统错误，请刷新！', {icon: 1});
                    this.$message('系统错误，请刷新！');
                });
            },

            // 留着，发送给三个车队的方法
            onSubmit() {
                var that = this;
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if(that.form.startCity == undefined || that.form.startCity.length <= 0){
                    // layer.msg('出发城市不能为空~', {icon: 2});
                    this.$message('出发城市不能为空~');
                    return;
                }
                if(that.form.telephone == undefined || that.form.telephone.length <= 0){
                    // layer.msg('手机号码不能为空~', {icon: 2});
                    this.$message('手机号码不能为空~');
                    return;
                }

                if (!myreg.test(that.form.telephone)) {
                    /*layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });*/
                    this.$message(res.message);
                    return;
                }

                /*that.shaindex = layer.load(1, {
                    shade: [0.1,'#fff'] //0.1透明度的白色背景
                });*/
                //循环组装车队id
                that.teamList.forEach((item) => {
                    that.team_id_list = that.team_id_list + item.team_id + ",";
                    that.cityinfo_id_list = that.cityinfo_id_list + item.city_info_id + ",";
                })
                that.cityinfo_id_list = that.cityinfo_id_list.substr(0, that.cityinfo_id_list.length - 1);
                that.team_id_list = that.team_id_list.substr(0, that.team_id_list.length - 1);
                that.$axios.post('/CustomizedItinerary', {
                    start_city:that.form.startCity[1],
                    source:"PC",
                    mobile:that.form.telephone,
                    team_id:that.team_id_list,
                    city_info_id:that.cityinfo_id_list
                }).then((res) => {
                    res = res.data;
                    // console.log(res)
                    if (res.status == 200) {
                        that.form.startCity = [];
                        that.form.startDetail = '';
                        that.form.endCity = [];
                        that.form.endDetail = '';
                        that.form.number = '';
                        that.form.radio = '1';
                        that.form.telephone = '';
                        // layer.closeAll();
                    } else {
                        // layer.closeAll();
                        // layer.msg('网络异常，请刷新！', {icon: 2});
                        this.$message('网络异常，请刷新！');
                    }

                }).catch((error) => {
                    // console.log(error);
                });
            },
            remainTime() {
                clearTimeout(this.timer);
                var one_r = Math.floor(Math.random() * 10);
                this.pic_one = this.pic_arr[one_r];
                var two_r = Math.floor(Math.random() * 10);
                this.pic_two = this.pic_arr[two_r];
                var three_r = Math.floor(Math.random() * 10);
                this.pic_three = this.pic_arr[three_r];
                var four_r = Math.floor(Math.random() * 10);
                this.pic_four = this.pic_arr[four_r];
                this.timer = setTimeout(this.remainTime, 600);
            },
            getCityData() {
                var that = this;
                that.$axios.get('/provinceAndCity', {

                }).then((res) => {
                    res = res.data;
                    // console.log(res)
                    if (res.status == 200) {
                        that.options = res.data;
                    } else {
                        // layer.msg('获取城市数据错误，请刷新！', {icon: 2});
                        this.$message('获取城市数据错误，请刷新！');
                    }
                }).catch((error) => {
                    // console.log(error);
                });
            },
            startcityChange() {
                var that = this;
                //切换城市之后显示的
                that.$axios.post('/cityNameGetId', {
                    city_name: that.form.startCity[1],
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.cityId = res.data;
                        that.getTeamList(that.cityId); //获取本地车队列表
                    } else {
                        // layer.msg('系统错误，请刷新！', {icon: 2});
                        this.$message('系统错误，请刷新！');
                    }
                }).catch((error) => {
                    // console.log(error);
                });
            },
            getTeamList(id) {
                var that = this;
                if (id != '') {
                    that.$axios.post('/CustomizedItineraryTeam', {
                        city_id: id
                    }).then((res) => {
                        res = res.data;
                        if (res.status == 200) {
                            that.teamList = res.data;
                        } else {
                            // layer.msg('数据获取失败，请刷新！', {icon: 2});
                            this.$message('数据获取失败，请刷新！');
                        }
                    }).catch((error) => {
                        // console.log(error);
                    });
                } else {
                    // layer.msg('请选择城市！');
                    this.$message('请选择城市！');
                }
            },


            showTelephone(){
                var team;
                var mobile;
                var start_city
                if(this.telShow){
                    return;
                } else {
                    start_city = this.form.startCity[1] ? this.form.startCity[1] : this.$store.state.cityName;
                    this.$axios.post('https://api.hbc1223.com/api/averageDistributionMobile',{
                        start_city: start_city
                    }).then((res)=>{
                        // layer.closeAll();
                        res = res.data;
                        if(res.status == 200){
                            team = res.data.team;
                            mobile = res.data.mobile;
                            this.bindTel(team,mobile);
                        } else {
                            // console.log(res.data);
                            // layer.msg('获取失败！', {icon: 2});
                            this.$message('获取失败！');
                        }
                    }).catch((error)=>{
                        // layer.closeAll();
                    });
                }
            },

            bindTel(team,mobile){
                var start_city = this.form.startCity[1] ? this.form.startCity[1] : this.$store.state.cityName;
                var userIp = this.getuserIp;
                var url = localStorage.getItem('now_url');
                this.$axios.post('https://api.hbc1223.com/api/BindFictitious',{
                    city: start_city,
                    referrer: '',
                    url: url,
                    info_id: userIp,
                    from: 14,
                    team: team,
                    phone: mobile,
                    source: "获取号码",
                }).then((res)=>{
                    res = res.data;
                    if(res.status == 200){
                        // console.log(res.data);
                        this.xuniTelephone = res.data;
                        this.telShow = true;
                        var timeClose = 180;
                        this.timerDjs = setInterval(()=> {
                            timeClose = timeClose-1;
                            // console.log(timeClose);
                            if(timeClose == 0){
                                this.telShow = false;
                                clearInterval(this.timerDjs);
                            }
                        },1000);
                    } else {
                        console.log(res);
                    }
                }).catch((error)=>{
                    console.log(error);
                });
            },
            enter(){
                this.hoverIcon = false;
            },
            leave(){
                this.hoverIcon = true;
            },
        }
    }
</script>

<style scoped>
    @import './offer.css';
</style>



// WEBPACK FOOTER //
// src/pages/offer/offer.vue